import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaTrash, FaChevronLeft } from 'react-icons/fa';
import v1 from "../Images/v1.mp4";
import './Cart.css';

const Cart = () => {
  const [cart, setCart] = useState([]);
  const [couponCode, setCouponCode] = useState('');
  const [discount, setDiscount] = useState(0);

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
    setCart(storedCart);
  }, []);

  const handleRemoveFromCart = (id) => {
    const updatedCart = cart.filter(item => item.id !== id);
    setCart(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };

  const handleQuantityChange = (id, quantity) => {
    const updatedCart = cart.map(item =>
      item.id === id ? { ...item, quantity } : item
    );
    setCart(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };

  const handleApplyCoupon = () => {
    if (couponCode === 'GOLD20') {
      setDiscount(19815);  // Example: 20% discount
    } else {
      alert('Invalid Coupon');
    }
  };

  const handleProceedToCheckout = () => {
    // Logic to navigate to checkout
  };

  const totalPrice = cart.reduce((total, item) => {
    const price = item.selectedMetalQuality === '18Kt'
      ? item.price_18kt
      : item.price_14kt;
    return total + (parseFloat(price) * item.quantity);
  }, 0);

  const finalPrice = totalPrice - discount;

  return (
<div className="cart-page">
  <header className="cart-header">
    <Link to="/" className="back-link">
      <FaChevronLeft /> Continue Shopping
    </Link>
    <h2 className="cart-title">Your Cart</h2>
  </header>

  <div className="cart-container">
    {/* Left side: items */}
    <div className="cart-items">
      {cart.length === 0 ? (
            <div className="d-flex align-items-center justify-contnet-center">
         <div className="empty-cart-container">

<video 
  className="empty-cart-gif" 

  autoPlay 
  loop 
  muted 
  src={v1} 
  alt="Empty cart" 
></video>

    <h3>There is nothing here!</h3>
    <p className="empty-cart-text">
      Let's do some retail therapy and find something you love.
    </p>
    <Link to="/" className="continue-shopping-btn">
      Continue Shopping
    </Link>
  </div>

  </div>

      ) : (
        cart.map(item => (
          <div key={item.id} className="cart-item-card">
            <img src={item.image_path} alt={item.name} className="cart-img" />
            <div className="cart-details">
              <h4>{item.name}</h4>
              <span className="meta">{item.selectedColor} | {item.selectedMetalQuality}</span>

              <div className="qty-price">
                <div className="quantity-control">
                  <button onClick={() => handleQuantityChange(item.id, item.quantity - 1)}>-</button>
                  <span>{item.quantity}</span>
                  <button onClick={() => handleQuantityChange(item.id, item.quantity + 1)}>+</button>
                </div>
                <p className="item-price">
                  ₹{parseFloat(item.selectedMetalQuality === '18Kt' ? item.price_18kt : item.price_14kt).toLocaleString()}
                </p>
              </div>

              <div className="item-footer">
                <p className="item-total">
                  Total: ₹{(parseFloat(item.selectedMetalQuality === '18Kt' ? item.price_18kt : item.price_14kt) * item.quantity).toLocaleString()}
                </p>
                <button className="remove-btn" onClick={() => handleRemoveFromCart(item.id)}>
                  <FaTrash /> Remove
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>

    {/* Right side: summary */}
    {cart.length > 0 && (
      <div className="cart-summary">
        <h3>Order Summary</h3>
        <div className="summary-item">
          <span>Subtotal</span>
          <span>₹{totalPrice.toLocaleString()}</span>
        </div>
        <div className="summary-item">
          <span>You Saved</span>
          <span className="save-amount">₹{discount.toLocaleString()}</span>
        </div>
        <div className="summary-item coupon-section">
          <input 
            type="text" 
            placeholder="Coupon Code" 
            value={couponCode} 
            onChange={(e) => setCouponCode(e.target.value)} 
          />
          <button onClick={handleApplyCoupon}>Apply</button>
        </div>
        <div className="summary-item">
          <span>Shipping</span>
          <span>Free</span>
        </div>
        <div className="summary-total">
          <span>Total</span>
          <span>₹{finalPrice.toLocaleString()}</span>
        </div>
        <button className="checkout-btn">Proceed to Checkout</button>
      </div>
    )}
  </div>
</div>

  );
};

export default Cart;
